 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		69: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"86cde62dc8c61fdd4e8fded2ceeb5a9460087d2d","1":"2bb4ab427c2fcbdc64f4a2470774136130644f7e","2":"9bd8402b9b8804e56fc828abd09aa1845f679bf0","4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-js","6":"component---src-pages-articles-abdominal-bloating-js","7":"component---src-pages-articles-bowel-cancer-screening-js","8":"component---src-pages-articles-bowel-polyps-js","9":"component---src-pages-articles-capsule-endoscopy-js","10":"component---src-pages-articles-coeliac-disease-js","11":"component---src-pages-articles-constipation-js","12":"component---src-pages-articles-covid-19-planning-js","13":"component---src-pages-articles-covid-19-planning-old-js","14":"component---src-pages-articles-covid-19-telehealth-js","15":"component---src-pages-articles-diverticulosis-and-diverticulitis-js","16":"component---src-pages-articles-endoscopic-retrograde-cholangiopancreatography-ercp-js","17":"component---src-pages-articles-fatty-liver-js","18":"component---src-pages-articles-gallstones-js","19":"component---src-pages-articles-gastroenteritis-in-children-js","20":"component---src-pages-articles-haemochromatosis-js","21":"component---src-pages-articles-heartburn-and-reflux-js","22":"component---src-pages-articles-helicobacter-pylori-js","23":"component---src-pages-articles-hepatitis-a-js","24":"component---src-pages-articles-hepatitis-b-js","25":"component---src-pages-articles-hepatitis-c-js","26":"component---src-pages-articles-index-js","27":"component---src-pages-articles-inflammatory-bowel-disease-ibd-crohns-and-colitis-js","28":"component---src-pages-articles-iron-deficiency-js","29":"component---src-pages-articles-irritable-bowel-syndrome-ibs-js","30":"component---src-pages-articles-lactase-deficiency-lactose-intolerance-js","31":"component---src-pages-articles-non-coeliac-gluten-sensitivity-real-or-imagined-js","32":"component---src-pages-articles-ppis-and-dementia-js","33":"component---src-pages-articles-pruritis-ani-js","34":"component---src-pages-contact-js","35":"component---src-pages-index-js","36":"component---src-pages-newsletters-index-js","37":"component---src-pages-our-team-angel-li-js","38":"component---src-pages-our-team-claire-gordon-js","39":"component---src-pages-our-team-daniel-cheng-js","40":"component---src-pages-our-team-danielle-lam-js","41":"component---src-pages-our-team-duy-pham-js","42":"component---src-pages-our-team-hannah-hessamodini-js","43":"component---src-pages-our-team-ian-yusoff-js","44":"component---src-pages-our-team-index-js","45":"component---src-pages-our-team-katrina-rogers-js","46":"component---src-pages-our-team-kelly-morgan-js","47":"component---src-pages-our-team-lorenzo-tarquinio-js","48":"component---src-pages-our-team-marcelo-leal-js","49":"component---src-pages-our-team-muna-salama-js","50":"component---src-pages-our-team-nabil-siddique-js","51":"component---src-pages-our-team-sam-rao-js","52":"component---src-pages-our-team-spiro-raftopoulos-js","53":"component---src-pages-patient-information-fees-and-charges-js","54":"component---src-pages-patient-information-first-visit-js","55":"component---src-pages-patient-information-index-js","56":"component---src-pages-patient-information-new-referrals-js","57":"component---src-pages-patient-information-patient-forms-js","58":"component---src-pages-services-bowel-cancer-screening-js","59":"component---src-pages-services-bowel-preparation-js","60":"component---src-pages-services-colonoscopy-js","61":"component---src-pages-services-endoscopic-retrograde-cholangiopancreatography-ercp-js","62":"component---src-pages-services-flexible-sigmoidoscopy-js","63":"component---src-pages-services-gastroscopy-upper-endoscopy-js","64":"component---src-pages-services-index-js","65":"component---src-pages-services-percutaneous-endoscopic-gastrostomy-peg-js","66":"component---src-pages-testimonials-js"}[chunkId]||chunkId) + "-" + {"0":"555192bdc129d6dab053","1":"8a1354f2cfc3b22245c1","2":"f4583d9372f8676fb558","4":"e5a749bf51cd94a9883d","5":"7d5c64af1312c77663b6","6":"b98b5198fa2a1d0f176a","7":"405d6de84d000cdf7d56","8":"848bb751b76f230421f7","9":"44d289bed4d937e3acbd","10":"2de82cce7022bacb2598","11":"c2f3d005db8f7b790675","12":"324cc9e3ada8a2878598","13":"4aea65dc3a8e15a4c535","14":"3eafbefa51df001c2251","15":"d123fc1452c9c024d939","16":"0e67f91a45136c73e3b2","17":"05deeb0186ba03f8df05","18":"22cc16547f9e62514727","19":"66dab3074c80721469bf","20":"7c133863dd7a58a9f95f","21":"c57df11a3b364f540614","22":"4d3f0e7f7adec55ba180","23":"569d01e7ee84d491e24a","24":"cb5ac92569be8eec774b","25":"0cae49b864617f51172b","26":"ddbfa159c08929372b88","27":"e2128a169fe53e366f53","28":"b3b0977f3023206b4494","29":"f82fa1256bb6bab6940e","30":"b581db3185b9d79bb74d","31":"689c6edb45c5dd112e03","32":"54ad70bc4fb0e3b6db6e","33":"d632f634464bb74ceb27","34":"04632854e86e96815b4e","35":"5c3b07510079f9338b53","36":"67669727e84dc2dac5b4","37":"69608451b19ac806f887","38":"28678d3d5cc04e96233e","39":"4b34d10daaeee59fefcb","40":"9a60fdf8346bd3034916","41":"ba5c2939d68f34a9c2f8","42":"6d1846e124bddce18fa8","43":"b22c4064bb8b823d795b","44":"9f7fcb2b634db046d15f","45":"29f25630ec45d72593d4","46":"d07aba8e6d5e16e668c6","47":"d5a9f57bda3a21ea4786","48":"4f482d2f78ff38014f4a","49":"66390b331260f2cf969e","50":"7b83f0cc1a1437bcfa5f","51":"ef9a64a2cf48837ea0df","52":"a7ab188bb98bf978f984","53":"5930cdfc1af7b3284efc","54":"e994a30fc86e4ce6f40a","55":"6673e4e9613ce432af19","56":"b31ce2ddf7a8dee9107f","57":"0981e45a2e66f30f05be","58":"92123ace60e0548b1113","59":"34c50ebd88da14f914aa","60":"621131f9bf192a2de95f","61":"5e5405317fb0e10e74ad","62":"1d417f11495cbb10beb5","63":"993fdccf49dfe091cd1e","64":"5dd6feedca7ef037b1b3","65":"f386c3a101802362f1fb","66":"1d3f6d5fb66383d11915"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
